const employer_pocs_uischema = {
  view: "sub",
  title: {
    profileName: "[profile name]",
    legalBusinessName: "Microsoft",
    fein: "XX-XXXXXXX",
    individuals: [],
  },
  entity: "Points of Contact",
  linkBack: {
    name: "Back to Employer Profiles",
    link: "/dashboard/profiles/employer",
  },
  button: {
    name: "New Point of Contact",
    style: "outline",
  },
};

export default employer_pocs_uischema;
